import { application } from "./application"

import ProgressBarController from "./progress_bar_controller"
import ProgressPollerController from "./progress_poller_controller"
import ChartController from "./chart_controller"
import PeriodSwitcherController from "./period_switcher_controller"

application.register("progress-bar", ProgressBarController)
application.register("progress-poller", ProgressPollerController)
application.register("chart", ChartController)
application.register("period-switcher", PeriodSwitcherController)
